module.exports = __webpack_public_path__ + "static/media/buttonu.c7e1c54c.svg";